import { User } from '../../../../../../../models/User';
import { canUserViewPrivateComments } from '../../permissions';

export type MentionableUsersOptions = {
  isPrivate: boolean;
  guestVisible: boolean;
  assignGuestsAllowed: boolean;
  assignGuests: boolean;
  assignees: { id: number | string }[];
  excludeUserId?: number | string | null;
};

export function getMentionableUsers(
  users: User[],
  {
    isPrivate,
    guestVisible,
    assignGuestsAllowed,
    assignGuests,
    assignees,
    excludeUserId
  }: MentionableUsersOptions
): User[] {
  const usersAccumulator: { guests: User[]; members: User[]; collabs: User[] } = {
    guests: [],
    members: [],
    collabs: []
  };
  const { guests, members, collabs } = users
    .filter(
      (user: User) =>
        (excludeUserId == null || String(user.id) !== String(excludeUserId)) &&
        (user.role !== 'guest' ||
          guestVisible ||
          (assignGuestsAllowed &&
            assignGuests &&
            assignees.find(({ id }) => id === user.id))) &&
        (!isPrivate || canUserViewPrivateComments(user))
    )
    .reduce((acc, user) => {
      acc[
        user.role === 'guest' ? 'guests' : user.role === 'collaborator' ? 'collabs' : 'members'
      ].push(user);
      return acc;
    }, usersAccumulator);

  guests.sort((a, b) => (a.name || a.email || '').localeCompare(b.name || b.email || ''));
  collabs.sort((a, b) => a.name.localeCompare(b.name));
  members.sort((a, b) => a.name.localeCompare(b.name));

  return [...members, ...collabs, ...guests];
}
